import axiosInstance from "../api";
import { urtoast } from "../../Components/Layouts/CustomPopup/eventEmitter";
import {
  GET_AUCTION,
  GET_AUCTION_BY_ID,
  GET_AUCTION_MINE,
  GET_MINE_AUCTION_ORDER_DETAILS,
  GET_AUCTION_ORDER_DETAILS,
  GET_FILTERD_AUCTION,
  GET_MINE_RENTAL_ORDER,
  GET_MINE_ACTIVE_AUCTION_ORDER_DETAILS,
} from "../constants";
import { getPostCounts } from "../posts/action";

const laung = localStorage.getItem("laung")

export const getActionList = (type) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`auction`);
    if (response?.data?.status) {
      dispatch({ type: GET_AUCTION, getauctionlist: response?.data?.response });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const FilterActionListings = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.post("auction", data);
    if (response?.data?.status) {
      dispatch({ type: GET_FILTERD_AUCTION, getfilterdaction: response.data });
      return;
    }
    console.error();
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    console.error();
    //urtoast(err.message, 2);
  }
};

export const getMineAuctionList = (type) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`auction?is_mine=1`);
    if (response?.data?.status) {
      dispatch({
        type: GET_AUCTION_MINE,
        getmineauctionlist: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const addAuction = (data, setLoading) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.post("auction/create", data);
    if (response?.data?.status) {
      setLoading(false);
      dispatch(getMineAuctionList());
      dispatch(getPostCounts(6))
      urtoast(response?.data?.response?.message, 1);
      return;
    }
    console.error();
    urtoast(response?.data?.response?.message, 2);
    setLoading(false);
  } catch (err) {
    setLoading(false);
    console.error();
    //urtoast(err.message, 2);
  }
};

export const updateAuction = (data, setLoading) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.put("auction/update", data);
    if (response?.data?.status) {
      setLoading(false);
      dispatch(getMineAuctionList());
      urtoast(response?.data?.response?.message, 1);
      return;
    }
    urtoast(response?.data?.response?.message, 2);
    setLoading(false);
  } catch (err) {
    setLoading(false);
    //urtoast(err.message, 2);
  }
};

export const getAuctionById = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`auction/id?id=${id}`);
    if (response?.data?.status) {
      dispatch({
        type: GET_AUCTION_BY_ID,
        getauctionbyid: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const deleteAuction = (id, setLoading) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.delete(`auction/delete?id=${id}`);
    if (response?.data?.status) {
      setLoading(false);
      dispatch(getPostCounts(6));
      dispatch(getMineAuctionList());
      urtoast(response?.data?.response?.message, 1);
      return;
    }
    urtoast(response?.data?.response?.message, 2);
    setLoading(false);
  } catch (err) {
    setLoading(false);
    //urtoast(err.message, 2);
  }
};

export const doAutionBid = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.post("auction/bid/create", data);
    if (response?.data?.status) {
      dispatch(getAuctionById(data?.auction_id))
      urtoast(response?.data?.response?.message, 1);
    } else {
      urtoast(response?.data?.response?.message, 2);
      return response
    }
  } catch (err) {
    console.error();
    //urtoast(err.message, 2);
  }
};

export const getAutionMineOrderList = (status) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(
      `auction?is_mine=1&status=${status}`
    );
    if (response?.data?.status) {
      dispatch({
        type: GET_MINE_AUCTION_ORDER_DETAILS,
        autionmineorderlist: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};
export const getActiveAutionMineOrderList = (status) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(
      `auction?is_mine=1&status=${status}`
    );
    if (response?.data?.status) {
      dispatch({
        type: GET_MINE_ACTIVE_AUCTION_ORDER_DETAILS,
        activeautionmineorderlist: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getAutionOrderList = (status) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`auction?status=${status}`);
    if (response?.data?.status) {
      dispatch({
        type: GET_AUCTION_ORDER_DETAILS,
        autionorderlist: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const doEndAution = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.put("auction/bid/update", data);
    if (response?.data?.status) {
      urtoast(response?.data?.response?.message, 1);
      dispatch(getAuctionById(data?.id));
    } else {
      urtoast(response?.data?.response?.message, 2);
    }
  } catch (err) {
    console.error();
    //urtoast(err.message, 2);
  }
};

export const payDepositminimumamount = (data, navigate) => async (dispatch) => {

  try {
    const payload = { ...data, wallet: data?.wallet || 0 };
    const response = await axiosInstance.post("payment", payload);
    if (response?.data?.status) {
      urtoast(response?.data?.response?.message, 1);
      dispatch(getAuctionById(data?.id));
      navigate(`/${laung}/auctiondetails/${data.auction_id}`);
    } else {
      urtoast(response?.data?.response?.message, 2);
    }
  } catch (err) {
    console.error();
    //urtoast(err.message, 2);
  }
};

export const payAutionAmount = (data, navigate) => async (dispatch) => {
  try {
    const payload = { ...data, wallet: data?.wallet || 0 };
    const response = await axiosInstance.post("payment", payload);
    if (response?.data?.status) {
      urtoast(response?.data?.response?.message, 1);
      navigate(-2);
      dispatch(getAuctionById(data?.id));
    } else {
      urtoast(response?.data?.response?.message, 2);
    }
  } catch (err) {
    console.error();
    //urtoast(err.message, 2);
  }
};

export const updateAuctionStatus = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.put("auction/bid/update", data);
    if (response?.data?.status) {
      urtoast(response?.data?.response?.message, 1);
      dispatch(getAuctionById(data?.id));
    } else {
      urtoast(response?.data?.response?.message, 2);
    }
  } catch (err) {
    console.error();
    //urtoast(err.message, 2);
  }
};

export const auctionRequest =
  (data, setLoading, navigate) => async (dispatch) => {
    try {
      const response = await axiosInstance.put("auction/bid/update", data);
      if (response?.data?.status) {
        urtoast(response?.data?.response?.message, 1);

        if (response?.data?.response) {
          setLoading(false);
          navigate(data?.url, {
            state: {
              orderdetails: {
                ...data?.state,
              },
            },
          });
          urtoast(response?.data?.response?.message, 1);
        }
      } else {
        urtoast(response?.data?.response?.message, 2);
      }
    } catch (err) {
      console.error();
      //urtoast(err.message, 2);
    }
  };

export const auctionRequestAPI = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.put("auction/update", data);
    if (response?.data?.status) {
      urtoast(response?.data?.response?.message, 1);
      if (response?.data?.response) {
        urtoast(response?.data?.response?.message, 1);
      }
    } else {
      urtoast(response?.data?.response?.message, 2);
    }
  } catch (err) {
    console.error();
    //urtoast(err.message, 2);
  }
};
